// import FormField to handle postcode input changes and form submission.
import useAddressSearch from "../../hooks/useAddressSearch";
import ErrorBoundary from "../layout/ErrorBoundary";
import FormField from "../layout/FormField";

// Import the MeterDetailsView component to display meter details for the selected address.
import MeterDetailsView from "./MeterDetailsView";

const AddressSearch: React.FC = () => {
  const {
    postcodeInput,
    setPostcodeInput,
    error,
    addressResults,
    selectedAddress,
    meterDetails,
    isLoading,
    handleSearch,
    handleAddressSelection,
  } = useAddressSearch();

  return (
    <div className="search-form">
      {/* Render the form input field to allow the user to enter a postcode and trigger a search on submit. */}
      {/* The onChange function updates the setPostcodeInput state whenever the user types in the input field. */}
      <FormField
        inputFields={[
          {
            id: "postcode",
            placeholder: "Enter a postcode",
            value: postcodeInput,
            onChange: setPostcodeInput,
          },
        ]}
        onSubmit={handleSearch}
        disabled={isLoading}
        testIdPrefix="electralink-address"
      />

      {/* In case of an error, display the error message on the UI. */}
      {error && (
        <div className="error-message" data-testid="electralink-address-error">
          {error}
        </div>
      )}
      {/* Display a 'loading' indicator to provide UI feedback to users as they await the API response. */}
      {isLoading && (
        <div className="electralink-loading-message" data-testid="electralink-address-loading">
          Loading...
        </div>
      )}

      {/* If the addressResults exist, render a <select> dropdown to display the retrieved addresses, and allow the user to select an address from the search results. */}
      {addressResults.length > 0 && !isLoading && (
        <div className="address-selection">
          <label htmlFor="address-select">Select an address:</label>
          <select
            id="address-select"
            data-testid="electralink-address-select"
            onFocus={(e) =>
              (e.target.size = addressResults.length > 15 ? 15 : addressResults.length)
            }
            onBlurCapture={(e) => (e.target.size = 1)}
            value={selectedAddress}
            onChange={(e) => {
              void handleAddressSelection(e.target.value);
            }}
            className="form-select"
            disabled={isLoading}
          >
            {!meterDetails && <option value="">Select an address</option>}
            {addressResults.map((address, index) => (
              <option key={index} value={address.address}>
                {address.address}
              </option>
            ))}
          </select>
        </div>
      )}

      {/* Display meter details if they exist for the selected address. */}
      <ErrorBoundary level="section" label="these results" resetKey={meterDetails}>
        {meterDetails && <MeterDetailsView meterDetails={meterDetails} />}
      </ErrorBoundary>
    </div>
  );
};

export default AddressSearch;
